import React, { CSSProperties } from 'react';
import { Swipe, SwipeItem } from 'swipejs/react';
import 'swipejs/style.css';

const PageNavBullet = (props: {
  isSelected: boolean;
  onClick: () => void;
  style?: CSSProperties;
}) => (
  <div
    style={{
      cursor: 'pointer',
      ...props.style,
    }}
    onClick={props.onClick}
  />
);

interface SwipeableCardsProps {
  items: any[];
  renderItem: (item: any) => JSX.Element;
  navBulletStyle?: (isSelected: boolean) => CSSProperties;
}

export const SwipeableCards = ({ items, renderItem, navBulletStyle }: SwipeableCardsProps) => {
  const swipeRef = React.useRef<any>();
  const [selectedItem, setSelectedItem] = React.useState(0);

  return (
    <>
      <Swipe
        ref={(ref: any) => (swipeRef.current = ref)}
        draggable={true}
        continuous={true}
        disableScroll={true}
        stopPropagation={true}
        transitionEnd={(index: number) => setSelectedItem(index)}
      >
        {items.map((r, index) => (
          <SwipeItem key={`swipeable-card-${index}`}>{renderItem(r)}</SwipeItem>
        ))}
      </Swipe>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          gap: 12,
          marginTop: 32,
        }}
      >
        {[...Array(items.length)].map((_, index) => (
          <PageNavBullet
            key={`swipeable-navBullet-${index}`}
            isSelected={selectedItem === index}
            onClick={() => swipeRef.current?.slide(index)}
            style={navBulletStyle?.(selectedItem === index)}
          />
        ))}
      </div>
    </>
  );
};
